import React, { useEffect, useState } from "react";
import "./Header.scss";
import {
  Modal,
  Icon,
  Header,
  Sidepanel,
  AppHeaderV2,
  TabsNavigation,
  Tab, 
  Toggle,
  HeaderNotificationPanel
} from "pepsico-ds";
import { logout } from "../../utils/auth/unified-auth";
import { useAuth } from "../../utils/auth/useAuth";
import { urlConstants } from '../../constants/urlConstants';
import  SproutAgro  from '../../assets/SproutAgro.svg'
import  Walkme_Guide  from '../../assets/Walkme_Guide.svg'
import SettingsModal from "./SettingsModal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {FetchNotificationsAction, ReadAllNotificationAction, ReadNotificationAction} from "../../redux/action/BroadcastAppBellAction";
import { useTour } from '../../routes/JoyrideProvide';
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { localStoreKeys } from "../../constants/localStoreKeys";

export default function MainHeader() {
  const { authState, authInstance } = useAuth();
  // useEffect(() => {
  //   const getUserDetails = async () => {
  //     await getOktaUserClaims(getOktaAuth());
  //   };
  //   getUserDetails();
  // }, []);
  const dispatch = useDispatch()
  const userData = useSelector((state) => state.getLandingPageReducer);
  const notificationApiResponse = useSelector((state) => state.fetchNotificationsReducer);

  const [openSettingsModal, setOpenSettingsModal] = useState(false)

  const [notificationPropClicked, setNotificationPropClicked] = useState(false)
  const [openNotificationModal, setOpenNotificationModal] = useState(false)
  const [notificationModalTitle, setNotificationModalTitle] = useState('')
  const [notificationModalText, setNotificationModalText] = useState('')
  const [notificationsVal, setNotificationsVal] = useState([])
  const [unreadCount, setUnreadCount] = useState(0)

  const [readClicked, setReadClicked] = useState(true)

  const { startTour } = useTour();

  /* istanbul ignore next */
  const clickOption = (keyName) => {
    if (keyName == 1) { // getting error
      window.open(urlConstants.errorPdf, "_blank", "noopener")
    }
    if (keyName == 2) { // support
      window.open(urlConstants.supportMail, "_blank", "noopener")
    }
    if (keyName === 3) { // logout
      logout();
    }
    if (keyName == 'logout') { // logout
      logout();
    }
    if(keyName == "settings"){
      setOpenSettingsModal(true)
    }
  }
  /* istanbul ignore next */
  useEffect(()=>{
    const button = document.querySelector('.sticky-footer > button');

    if (button) {
      // Change text
      button.textContent = "Email subscription";

      // Enable button
      button.disabled = false;
      button.removeAttribute("disabled");

      // Remove previous click handler if needed (optional)
      button.onclick = null;

      // Add new click behavior
      button.addEventListener("click", function () {
        // Your logic here
        setOpenSettingsModal(true)
      });
    }

  },[notificationPropClicked])
  /* istanbul ignore next */
  useEffect(()=>{
    if(userData?.emailId){
      let request={
        "emailId": userData?.emailId,
      }
      dispatch(FetchNotificationsAction(request))
    }

    // setNotificationsVal([{}])
    

  },[userData, openNotificationModal, notificationPropClicked])
  // },[userData, readClicked])
  /* istanbul ignore next */
   useEffect(() => {
      // document.addEventListener('DOMContentLoaded', function () {
        // const badge = document.querySelector('.atoms-badge-value');
        
        // if (badge) {
        //   badge.textContent = 5;
        // }
      // });
      let unreadVal = notificationApiResponse?.notifications?.filter(item => item.isRead === false).length;
      setUnreadCount(unreadVal)
      setNotificationsVal(notificationApiResponse?.notifications);
      // setNotificationsVal(dummydata);
    }, [notificationApiResponse]);
    /* istanbul ignore next */
    useEffect(()=>{
      const profileMenu = document.querySelector('.profile-menu');
      const notificationMenu = document.querySelector('.header-notification-panel');
      if (profileMenu) {
        profileMenu.style.setProperty('display', 'none', 'important');
      }
      if (notificationMenu) {
        notificationMenu.style.setProperty('display', 'none', 'important');
      }

    }, [openSettingsModal, openNotificationModal])
    /* istanbul ignore next */
    useEffect(()=>{
      // Select the element
    //  document.addEventListener('DOMContentLoaded', function () {
        // const badge = document.querySelector('.atoms-badge-value');
        
        // if (badge) {
        //   badge.textContent = 5;
        // }
    //  });
    },[])
    /* istanbul ignore next */
    useEffect(() => {
      const updateBadge = () => {
        const badge = document.querySelector(".atoms-badge-value");
        const circleBadge = document.querySelector(".atoms-badge");

        if (!badge || !circleBadge) return false;

        if (unreadCount === 0) {
          circleBadge.style.display = "none";
        } else {
          circleBadge.style.display = "flex"; 
          badge.textContent = unreadCount;
        }

        const bellIcon = document.querySelector('[data-testid="notifications-wrapper"]');
        bellIcon.setAttribute("title", `Notifications`);
        const tourIcon = document.querySelector('[data-testid="rocket-wrapper"]');
        tourIcon.setAttribute("title", `Guided Tour`);
        return true;
      };

      // Try immediately once
      if (updateBadge()) return;

      // If not found, observe DOM
      const observer = new MutationObserver(() => {
        if (updateBadge()) {
          observer.disconnect(); // stop once updated
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      return () => observer.disconnect();
    }, [unreadCount]);

    /* istanbul ignore next */
    useEffect(() => {
      const img = new Image();
      img.src = Walkme_Guide;
    }, []);

  if(authState?.isAuthenticated){
  return (
    <>
      <AppHeaderV2
        appLogoProps={{
          appName: 'PROCUREMENT HUB',
          colorStyle: 'color',
          customLogo: {
            alt: 'Custom Logo',
            src: 'https://placehold.co/100x25',
            width: 100,
          },
          iconProps: {
            icon: 'apps'
          },
          showAppName: true,
          showCustomLogo: false,
          showIcon: false,
          className:"buy-con-logo"
        }}
        profileMenuProps={{
          onClickOption: function CFe(e){clickOption(e)},
          options: [
            {
              icon: 'report_problem',
              id: '1',
              title: 'Getting Error / Need help?',
              type: 'default'
            },
            {
              icon: 'mail',
              id: '2',
              title: 'Support',
              type: 'default'
            },
            // {
            //   icon: 'logout',
            //   id: '3',
            //   title: 'Log Out',
            //   type: 'default'
            // }
          ],
          profileDetails: {
            
            // avatarImage: <img alt="avatar" src="https://i.pravatar.cc/256"/>,
            // avatarImage: 'https://www.gravatar.com/avatar/?d=mp&s=200',
            avatarImage: 'https://static.vecteezy.com/system/resources/previews/013/360/247/original/default-avatar-photo-icon-social-media-profile-sign-symbol-vector.jpg',
            // icon: 'logout'
            // email: 'john.doe@example.com',
            // name: 'John Doe',
            // onClick: function CFe(){}
          },
          // showThemeSwitcher: true,
          // switcher: {
          //   defaultSelection: 'Auto',
          //   onUpdate: function CFe(){}
          // },
          title: 'Profile'
        }}
        // ={}
        notificationsProps={{
          
          notifications: notificationsVal,
          onClick: function ERe(id){
                              const found = notificationsVal.find(item => item.id === id);
                              setNotificationModalTitle(found?.title || "");
                              setNotificationModalText(found?.notificationBody || "");
                              let req = {
                                 "emailId": userData?.emailId,
                                  "notificationId": id
                              }
                              dispatch(ReadNotificationAction(req))
                              setOpenNotificationModal(true)
                              setReadClicked(!readClicked)
                              // let request={
                              //   "emailId": userData?.emailId,
                              // }
                              // dispatch(FetchNotificationsAction(request))
    
                              // setNotificationsVal([])
                            },
          // onDismiss: function ERe(e){console.log("delete id:", e)},
          onDismissAll: function ERe(){setOpenSettingsModal(true)},
          onReadAll: function ERe(){
                setNotificationsVal(prev =>
                  prev.map(item => ({
                    ...item,
                    isRead: true
                  }))
                );
                let req = {
                      "emailId": userData?.emailId
                }
                dispatch(ReadAllNotificationAction(req))
                // setReadClicked(!readClicked)
          },
          openAllNotifications: function ERe(){},
          popOverDirection: 'top-right',
          title: 'Notifications',
        }}
        
        showSideBar={false}
        sideMenuMobileProps={{
          onClickLogout: function CFe(){},
          onClickOption: function CFe(){},
        }}
        style={{}}
        onClick={function ERe(e){
                        console.log('e: ', e)
                        // if(e?.target?.innerText !== "Mark all as read"){
                        if(e?.target?.innerText == "notifications"){
                          setNotificationPropClicked(!notificationPropClicked)
                        }
                        if(e?.target?.innerText == "rocket_launch"){
                          dispatch(setKeyValue({ key: localStoreKeys.isStartTour, value: true }))
                          startTour();
                        }
                        
				}}
        className="custom-appHeader"
      />

      {
        openSettingsModal && 
        <SettingsModal 
        onClose={() => {
          setOpenSettingsModal(false)
        }} 
        // onTrigger={onTrigger}
        />
      }
      
      <Modal                   
                      className="broadcast-notification-modal"
                      closeOnOutsideClick={()=> setOpenNotificationModal(false)}
                    //   hideCloseButton
                      onCloseModal={function oFe(){setOpenNotificationModal(false)}}
                      primaryButtonProps={{
                      onClick: function x(){setOpenNotificationModal(false)},
                      size: 'medium',
                      text: 'Close',
                      variant: 'primary'
                      }}
                      showModal={openNotificationModal}
                      showLink={false}
                      showPrimaryButton={true}
                      showSecondaryButton={false}
                      showTertiaryButton={false}
                      showAuxiliaryButton={false}
                      type="M"
                      // title={notificationModalTitle}
                  >
                    <div style={{height: '100%'}}>
                            {/* Header */}
                            <div>
                                    <div className="notification-modal-title">{notificationModalTitle}</div>
                                    <br/>
                                    <div dangerouslySetInnerHTML={{ __html: notificationModalText }} />
                            </div>
                    </div>
                  </Modal>

    </>
  );
  }
}
